document.addEventListener("DOMContentLoaded", function () {
  // Find all add to cart elements
  const addToCartElements = document.querySelectorAll("[data-add-to-cart]");

  addToCartElements.forEach(function (element) {
    element.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation(); // Prevent the product link from being triggered

      // Prevent double execution
      if (this.classList.contains("loading-spinner")) {
        return;
      }

      const variantId = this.dataset.variantId;
      const productId = this.dataset.productId;

      if (!variantId) {
        console.error("No variant ID found");
        return;
      }

      // Show loading state
      this.classList.add("loading-spinner");

      // Add to cart
      addToCart(variantId, this);
    });
  });

  function addToCart(variantId, buttonElement) {
    const formData = {
      items: [
        {
          id: parseInt(variantId),
          quantity: 1,
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status && data.status !== 200) {
          // Handle error
          showMessage(
            data.description || "Error agregando al carrito",
            "error"
          );
        } else {
          // Success
          showMessage("Agregado al carrito!", "success");
          updateCartIcon();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        showMessage("Error agregando al carrito", "error");
      })
      .finally(() => {
        // Remove loading state
        buttonElement.classList.remove("loading-spinner");
      });
  }

  function updateCartIcon() {
    // Update cart count if you have a cart icon bubble
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const cartCountElement = document.querySelector("[data-cart-count]");
        if (cartCountElement) {
          cartCountElement.textContent = cart.item_count;
        }

        // Update cart drawer if it exists
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && cartDrawer.renderContents) {
          cartDrawer.renderContents({
            sections: {
              "cart-drawer": cart,
            },
          });
        }
      });
  }

  function showMessage(message, type = "success") {
    // Create a simple toast notification
    const toast = document.createElement("div");
    toast.className = `vinyl-toast vinyl-toast--${type}`;
    

    // Style the toast
    Object.assign(toast.style, {
      position: "fixed",
      top: "0px",
      display: "flex",
      alignItems: "center",

      background: type === "success" ? "#18dfba" : "#9c372f",
      fontSize: "20px",
      zIndex: "10000",
      transition: "all 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
      padding: "0px 24px",
      fontFamily: "Bebas Neue",
      width: "100vw",
      boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
      color: type === "success" ? "black" : "white",
      opacity: "0",
      justifyContent: "space-around",
    });


    // create a image with a blank src
    const image = document.createElement("img");
    image.src = "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMmtqMDFiZWIyZmpmdnl6OWM5dWE5em5penpraG9tejg3aGxjN282NCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/wcBVW9S9avoti/giphy.gif";
    image.style.width = "80px";
    image.style.height = "100%";
    image.style.objectFit = "cover";

    //create a p element with the message
    const p = document.createElement("p");
    p.textContent = message;
    p.style.margin = "0";

    toast.appendChild(p);
    toast.appendChild(image);
    
    document.body.appendChild(toast);

    // Animate in
    setTimeout(() => {
      toast.style.opacity = "1";
    }, 100);

    setTimeout(() => {
      toast.style.opacity = "0";
      setTimeout(() => {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 300);
    }, 3000);
  }
});
